import { RouteConfig } from 'vue-router';

import { BreadcrumbItem } from '@/interfaces/breadcrumbItem';
import { flat } from './flat';

/**
 * Pobiera listę elementów do wyświetlenia w breadcrumbsach
 *
 * @export
 * @param {*} routes
 * @param {any[]} [parents]
 * @returns {any[]}
 */
export function getBreadcrumbItems(routes: RouteConfig[], parents?: BreadcrumbItem[]): BreadcrumbItem[] {
  return flat(
    routes.map(route => {
      if (Array.isArray(route.meta?.breadcrumb)) {
        const breadcrumbs = [...route.meta.breadcrumb];
        const breadcrumb = breadcrumbs.pop();
        return routeItemToCrumbs({ ...route, meta: { ...route.meta, breadcrumb } }, [
          ...(parents || []),
          ...breadcrumbs.map((crumb: any) => ({ route: crumb }))
        ]);
      }
      return routeItemToCrumbs(route, parents);
    })
  );
}

/**
 * Mapuje element routera na element breadcrumbów
 *
 * @param {*} route
 * @param {BreadcrumbItem[]} [parents]
 * @returns {(BreadcrumbItem | BreadcrumbItem[])}
 */
function routeItemToCrumbs(route: RouteConfig, parents?: BreadcrumbItem[]): BreadcrumbItem | BreadcrumbItem[] {
  const breadcrumbData = (route.meta && route.meta.breadcrumb) || {};
  const crumb: BreadcrumbItem = { route: { name: route.name, ...breadcrumbData }, parents };
  if (route.children) {
    return crumbWithChildren(route, crumb);
  }
  return crumb;
}

/**
 * Zwraca breadcrumb wraz z dziećmi
 *
 * @param {*} route
 * @param {BreadcrumbItem} crumb
 * @returns
 */
function crumbWithChildren(route: RouteConfig, crumb: BreadcrumbItem) {
  const children = getBreadcrumbItems(
    route.children as RouteConfig[],
    crumb.parents ? [...crumb.parents, crumb] : [crumb]
  );
  return [crumb, ...children];
}
